import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";
import { getPrimaryImage } from "~/utils/product/getPrimaryImage";
import { useProductDetailsUrl } from "~/common/components/PackageRestrictionContext/useProductDetailsUrl";
import { IMG_MISSING_PRODUCT } from "~/utils/url/staticResources";
import { useForcedConfiguratorTranslations } from "~/Configurators/common/useXmlConfiguratorTranslations";
import { type ConfiguratorProductData, isConfiguratorProduct, type ProductData } from "~/models/ProductData";
import { ConfiguratorType } from "~/Configurators/ConfiguratorType";
import { RAIL_CONFIGURATOR_PRODUCT_CODE } from "~/Configurators/constants";
import { Suspense } from "react";

interface Props extends BaseProductElementProps {
  clickable?: boolean;
  linkProps?: JSX.IntrinsicElements["a"];
  width?: number;
  height?: number;
}

function isNewTypeConfiguratorProduct(product: ProductData): product is ConfiguratorProductData {
  return (
    isConfiguratorProduct(product) &&
    (product.configuratorType === ConfiguratorType.MetricShaft ||
      product.configuratorType === ConfiguratorType.InchShaft)
  );
}

const PrimaryImageInner = (props: Props) => {
  const { clickable = true, linkProps } = props;

  const product = useProductContext(props);
  // TODO - Fix this so it doesn't have to use the rail configurator product code
  const xmlT = useForcedConfiguratorTranslations(
    isConfiguratorProduct(product) ? product.code : RAIL_CONFIGURATOR_PRODUCT_CODE,
  )?.t;

  let imageUrl = IMG_MISSING_PRODUCT;
  const image = getPrimaryImage(product, { imageFormat: "thumbnail" });
  if (image) {
    if (isNewTypeConfiguratorProduct(product)) {
      imageUrl = xmlT?.(image.url) ?? image.url;
    } else {
      imageUrl = image.url;
    }
  }
  const pdpUrl = useProductDetailsUrl(product);

  let imageCmp = <img className={props.className} src={imageUrl} alt={image?.altText} {...props} />;
  if (clickable) {
    imageCmp = (
      <a href={pdpUrl} className={props.className} {...linkProps}>
        {imageCmp}
      </a>
    );
  }

  return imageCmp;
};

export const PrimaryImage = (props: Props) => {
  return (
    <Suspense fallback={null}>
      <PrimaryImageInner {...props} />
    </Suspense>
  );
};
